import * as React from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { withBaseProps } from '../Utils';
import { ButtonVariants } from './Button';
import { Button } from './index';
const ButtonWithConfirm = (props) => {
    const { className: classNameProp, loading, disabled, iconName, t, handleCallback, actionLabel, confirmLabel, confirmCounter, testId = 'ButtonWithConfirm', callback, } = props;
    const label = confirmCounter === 0 ? actionLabel : confirmLabel || t('common:confirm');
    const variant = confirmCounter === 0 ? ButtonVariants.secondary : ButtonVariants.error;
    return (React.createElement(Button, { className: classNameProp, variant: variant, iconName: iconName, iconColor: "currentColor", iconSize: 18, isLoading: loading, disabled: disabled, onClick: handleCallback(callback), label: label, "data-testid": `${testId}` }));
};
export default compose(withBaseProps({}), withState('confirmCounter', 'setConfirmCounter', 0), withState('timeoutId', 'setTimeoutId', 0), lifecycle({
    componentWillUnmount() {
        this.props.timeoutId && clearTimeout(this.props.timeoutId);
    },
}), withHandlers({
    handleSetDeleteConfirm: ({ setConfirmCounter, timeoutConfirmMs, setTimeoutId }) => (counter) => {
        setConfirmCounter(counter);
        const confirmTimeoutId = setTimeout(() => {
            setConfirmCounter(0);
        }, timeoutConfirmMs || 3000);
        setTimeoutId(confirmTimeoutId);
    },
}), withHandlers({
    handleCallback: ({ timeoutId, confirmCounter, handleSetDeleteConfirm }) => (callback) => () => {
        if (confirmCounter === 0) {
            handleSetDeleteConfirm(1);
        }
        else {
            handleSetDeleteConfirm(0);
            clearTimeout(timeoutId);
            callback();
        }
    },
}))(ButtonWithConfirm);
//# sourceMappingURL=ButtonWithConfirm.js.map